var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey},[_c('div',{attrs:{"id":"swiper_container"}},[_c('BetMatchDetailsSwiper',{attrs:{"matches":_vm.matches}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }